import type { Startup } from '@/types/data';
import type { Filters } from '@/types/filters';

export const applyFilters = (startups: Startup[], filters: Filters): Startup[] => {
  return startups.filter(s => {
    if (filters.searchQuery) {
      const q = filters.searchQuery.toLowerCase();
      if (
        !s.name.toLowerCase().includes(q) &&
        !(s.category?.toLowerCase() ?? '').includes(q) &&
        !(s.subcategory?.toLowerCase() ?? '').includes(q)
      ) return false;
    }

    const mrr = s.mrr ?? 0;
    if (mrr < filters.mrrRange[0]) return false;
    if (filters.mrrRange[1] < Infinity && mrr > filters.mrrRange[1]) return false;

    const growth = s.growth_mrr_30d ?? 0;
    if (filters.growthRange[0] > -Infinity && growth < filters.growthRange[0]) return false;
    if (filters.growthRange[1] < Infinity && growth > filters.growthRange[1]) return false;

    const customers = s.customers ?? 0;
    if (customers < filters.customersRange[0]) return false;
    if (filters.customersRange[1] < Infinity && customers > filters.customersRange[1]) return false;

    if (filters.categories.size > 0 && (!s.category || !filters.categories.has(s.category))) return false;
    if (filters.subcategories.size > 0 && (!s.subcategory || !filters.subcategories.has(s.subcategory))) return false;
    if (filters.clusters.size > 0 && !filters.clusters.has(s.label_final)) return false;
    if (filters.countries.size > 0 && (!s.country || !filters.countries.has(s.country))) return false;
    if (filters.targetAudience && s.target_audience !== filters.targetAudience) return false;
    if (filters.onSale === true && !s.on_sale) return false;

    return true;
  });
};
